import { useContext } from "react";
import { Stack, Typography, Grid, Box } from "@mui/material";
import moment from "moment";
//Import from project
import "../../Style/pagestyle.scss";
import LoginImage from "../../Assets/logoSystem.png";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import LoadingPage from "../../Utils/LoadingPage";
import EmptyData from "../Include/EmptyData/EmptyData";
import useGetExpenseReport from "../../Hooks/useGetExpenseReport";
import {
  currencyFormat,
  currencyFormatRiel,
  generateInvoiceNumber,
} from "../../Function/DynamicFn";

export default function Expense({ componentRef, fromDate, toDate, type }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const { tableData, loading } = useGetExpenseReport({
    fromDate,
    toDate,
    type,
  });

  const totalAmount = tableData?.reduce((total, row) => {
    const totalRielAsDollar =
      row?.amountKHR > 0 ? row?.amountKHR / row?.exchangeRate : 0;

    return total + (row?.amountUSD || 0) + totalRielAsDollar;
  }, 0);
  // let totalAmount = 0;

  return (
    <div className="page-container">
      <Stack
        sx={{ padding: "20px" }}
        direction={"column"}
        spacing={1}
        ref={componentRef}
      >
        <Box>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <Stack direction="row" justifyContent={"left"}>
                <img alt="Logo" src={LoginImage} style={{ width: "120px" }} />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Typography className="report-table-title">
                {t("page_expense")}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Stack
                direction="row"
                justifyContent={"right"}
                sx={{ marginTop: "28px" }}
              >
                <Typography className="report-table-title">
                  Total: $ {currencyFormat(totalAmount)}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Box>

        {/* ================================ Table student and parents info ============================ */}
        <table className="report-table-container">
          <thead>
            <tr>
              <th style={{ width: "4%" }}>{t("no")}</th>
              <th style={{ width: "20%" }}>{t("thead_date")}</th>
              <th style={{ width: "20%" }}>{t("thead_type")}</th>
              <th style={{ width: "20%" }}>{t("thead_total_amount")} ($)</th>
              {/* <th style={{ width: "15%" }}>{t("thead_exchange_rate")}</th>
              <th style={{ width: "15%" }}>{t("thead_amount")} ($)</th>
              <th style={{ width: "15%" }}>{t("thead_amount")} (៛)</th> */}
              <th style={{ width: "36%" }}>{t("thead_description")}</th>
            </tr>
          </thead>

          {loading ? (
            <tbody>
              <tr>
                <td colSpan={16}>
                  <LoadingPage />
                </td>
              </tr>
            </tbody>
          ) : (
            <>
              {tableData?.length === 0 ? (
                <tbody>
                  <tr>
                    <td colSpan={16}>
                      <EmptyData />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {tableData?.map((row, index) => {
                    const totalRielAsDollar =
                      row?.amountKHR > 0
                        ? row?.amountKHR / row?.exchangeRate
                        : 0;
                    const totalAmount = row?.amountUSD + totalRielAsDollar;
                    return (
                      <tr key={index}>
                        <td align="center">{index + 1}</td>
                        <td align="center">
                          {row?.date && moment(row?.date).format("DD-MMM-YYYY")}
                        </td>
                        <td align="center">
                          {language === "en"
                            ? row?.type?.engType
                            : row?.type?.khType}
                        </td>
                        {/* <td align="right">
                          {currencyFormatRiel(row?.exchangeRate)} ៛
                        </td>
                        <td align="right">
                          $ {currencyFormat(row?.amountUSD)}
                        </td> */}
                        <td align="right">$ {currencyFormat(totalAmount)}</td>
                        <td align="left">{row?.remark}</td>
                      </tr>
                    );
                  })}

                  {/* <tr>
                    <th colSpan="5" align="center">
                      Total
                    </th>
                    <th style={{ color: "orange", textAlign: "right" }}>
                      $ {currencyFormat(totalOwe)}
                    </th>
                    <th style={{ color: "green", textAlign: "right" }}>
                      $ {currencyFormat(totalReceived)}
                    </th>
                    <th style={{ color: "red", textAlign: "right" }}>
                      $ {currencyFormat(totalAmount)}
                    </th>
                  </tr> */}
                </tbody>
              )}
            </>
          )}
        </table>
      </Stack>
    </div>
  );
}
